var exports = {
  "kL": "xe7b6e3d6--d83532--container",
  "pq": "xe7b6e3d6--d83532--info",
  "nf": "xe7b6e3d6--d83532--link",
};

module.exports = exports;
